export default "__VITE_ASSET__MKA1flSF__"